class ConsultationsAuthApiClient {
  constructor(client) {
    this.client = client
  }

  profile() {
    return this.client.get(`/api/v1/profile`).then((response) => response.data)
  }

  adminSignIn(credentials) {
    return this.client.post(`/admin/v1/login`, credentials).then((response) => response.data)
  }

  passwordForgotten(formValues) {
    return this.client.post(`/admin/v1/password/forgot`, formValues).then((response) => response.data)
  }

  passwordReset(formValues) {
    return this.client.post(`/admin/v1/password/reset`, formValues).then((response) => response.data)
  }

  passwordChange(data) {
    return this.client.put(`/admin/v1/password/change`, data).then((response) => response.data)
  }

  logout() {
    return this.client.post(`/admin/v1/logout`).then((response) => response.data)
  }

  updateLanguage(data) {
    return this.client.put(`/admin/v1/language_code/update`, data).then((response) => response.data)
  }

  ssoSignIn(credentials) {
    return this.client.get(`/admin/v1/saml2/pepsico/login`, credentials).then((response) => response.data)
  }
}

export default ConsultationsAuthApiClient
